import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> {
  label: string;
  error?: string;
  multiline?: boolean;
  options?: {
    value: string;
    label: string;
  }[];
}
export const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, InputProps>(({
  label,
  error,
  multiline,
  options,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const baseStyles = 'w-full px-4 py-2.5 bg-white border rounded-lg focus:outline-none focus:ring-2 transition-colors disabled:bg-warm-50 disabled:text-warm-500';
  const stateStyles = error ? 'border-red-300 focus:border-primary-600 focus:ring-primary-200' : 'border-black focus:border-primary-600 focus:ring-primary-200 hover:border-warm-600';
  return <div className={`w-full ${className}`} data-id="element-155">
      <label htmlFor={inputId} className="block text-sm font-medium text-warm-800 mb-1.5" data-id="element-156">
        {label}
      </label>

      {options ? <select id={inputId} ref={ref as React.Ref<HTMLSelectElement>} className={`${baseStyles} ${stateStyles}`} {...props as React.SelectHTMLAttributes<HTMLSelectElement>} data-id="element-157">
          <option value="" disabled data-id="element-158">
            Select an option
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-159">
              {opt.label}
            </option>)}
        </select> : multiline ? <textarea id={inputId} ref={ref as React.Ref<HTMLTextAreaElement>} className={`${baseStyles} ${stateStyles} min-h-[100px] resize-y`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-160" /> : <input id={inputId} ref={ref as React.Ref<HTMLInputElement>} className={`${baseStyles} ${stateStyles}`} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-161" />}

      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-162">
          {error}
        </p>}
    </div>;
});
Input.displayName = 'Input';